export default __webpack_public_path__ + "static/media/techbackground4.67923237.gif";